import { Button, PrettyCurrency } from 'components';
import { useTranslations } from 'next-intl';
import { useOrders } from 'providers/OrdersProviders/useOrders';
import { usePaymentRetry } from 'providers/OrdersProviders/usePaymentRetry';
import { usePuchaseOrderCancel } from 'providers/OrdersProviders/usePuchaseOrderCancel';
import { FC } from 'react';
import { PurchaseOrderUnitary } from '../_context/useTableOrders';

interface ITotalAmountOrder {
  purchaseOrder: PurchaseOrderUnitary;
}

const TotalAmountOrder: FC<ITotalAmountOrder> = ({ purchaseOrder }) => {
  const t = useTranslations();

  const { refetch } = useOrders();
  const { mutateAsync: puchaseOrderCancel, isPending: isCancelLoading } = usePuchaseOrderCancel({
    onSuccess: refetch as any
  });
  const { mutateAsync: paymentRetry, isPending: isRetryLoading } = usePaymentRetry({
    onSuccess: refetch as any
  });

  const { price, currency, paymentStatus } = purchaseOrder;

  const paymentSettled = paymentStatus === 'settled';
  const paymentNotApplicable = paymentStatus === 'na';
  const paymentPending = paymentStatus === 'pending';
  const paymentRequired = purchaseOrder.price > 0 && !(paymentSettled || paymentNotApplicable);

  return (
    <div className="flex items-center justify-between gap-1">
      <PrettyCurrency amount={price} currency={currency} className="!font-normal" />
      {paymentRequired && !paymentPending && (
        <div className="flex flex-col justify-between gap-4">
          <Button
            color="danger"
            label={t('billing.orders.index.cancel_order')}
            onClick={() => puchaseOrderCancel({ purchaseOrderId: purchaseOrder.id })}
            size="small"
            disabled={isCancelLoading}
            className="!p-0 !px-2"
            variant="outlined"
          />
          <Button
            label={t('billing.orders.index.retry_payment')}
            onClick={() => paymentRetry({ purchaseOrderId: purchaseOrder.id })}
            size="small"
            disabled={isRetryLoading}
            className="!p-0 !px-2"
            variant="outlined"
          />
        </div>
      )}
    </div>
  );
};

export default TotalAmountOrder;
